import React, { Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '../contexts/authContext.tsx';
import { PrivateRoute } from './privateRoute.tsx';
import LoadingComponent from '../components/loadingComponent/index.tsx';
import LancamentoForecast from '../pages/revenueManager/forecast-lancamento/index.tsx';

const AdicionarDados = React.lazy(() => import('../pages/AdicionarDados'));
const Analytics = React.lazy(() => import('../pages/analytics'));
const Analytics2 = React.lazy(() => import('../pages/analytics/home.tsx'));
const Login = React.lazy(() => import('../pages/login'));

const Anual = React.lazy(() => import('../pages/Topline/Anual/comparativoanual'));
const Performance = React.lazy(() => import('../pages/Topline/Comparativo/comparativoperformance'));
const Diario = React.lazy(() => import('../pages/Topline/Diario/comparativodiario'));
const Mensal = React.lazy(() => import('../pages/Topline/Mensal/comparativomensal'));

const AlugueisDividendos = React.lazy(() => import('../pages/Patrimoniais/AlugueisDividendos/investidores'));
const ExtratoFundoDeReservas = React.lazy(() => import('../pages/Patrimoniais/ExtratoFundoDeReservas'));
const ListaAcionistas = React.lazy(() => import('../pages/Patrimoniais/ListaAcionistas/acionistas'));

const DREComparativo = React.lazy(() => import('../pages/DRE/Comparativo/drecomparativo'));
const DREMensal = React.lazy(() => import('../pages/DRE/Mensal/dremensal'));
const DRERealizadoXOrcado = React.lazy(() => import('../pages/DRE/RealizadoXOrcado/realizadoXOrcado'));
const DreOrcadoXRealizadoNew = React.lazy(() => import('../pages/DRE/RealizadoXOrcado/realizadoXOrcadoV2.tsx'));
const RealizadoRealizado2 = React.lazy(() => import('../pages/DRE/RealizadoRealizadoV2/index.tsx'));

const EditarPermissoes = React.lazy(() => import('../pages/editarPermissoes'));
const Forecast = React.lazy(() => import('../pages/forecast/Forecast'));

const DefinicaoDePremissas = React.lazy(() => import('../pages/Budget/DefinicaoPremissas'));
const GestaoContratos = React.lazy(() => import('../pages/Budget/GestaoContratos'));
const QuadroDePessoal = React.lazy(() => import('../pages/Budget/QuadroPessoal'));
const ResumoBudget = React.lazy(() => import('../pages/Budget/resumoBudget/index.tsx'));

const RevenueManager = React.lazy(() => import('../pages/revenueManager/revenue-manager/index.tsx'));

const RegistroDiarioGourmet = React.lazy(() => import('../pages/gourmet/registroDiario'));
const RegistroMensalGourmet = React.lazy(() => import('../pages/gourmet/registroMensal'));
const GourmetControle = React.lazy(() => import('../pages/gourmetControle/gourmetControle'));

const Colaboradores = React.lazy(() => import('../pages/RecursosHumanos/Colaboradores'));
const NovoColaborador = React.lazy(() => import('../pages/RecursosHumanos/NovoColaborador'));
const PDI = React.lazy(() => import('../pages/RecursosHumanos/PDI'));
const PDIColaborador = React.lazy(() => import('../pages/RecursosHumanos/PDIColaborador'));
// const AdicionarAtualizacoes = React.lazy(() => import('../pages/atualizacoes-do-sistema/adicionarAtualizacoes.tsx'));
const AtualizacoesDoSistema = React.lazy(() => import('../pages/atualizacoes-do-sistema/atualizacoes.tsx'));
const UserProfile = React.lazy(() => import('../pages/perfil-usuario/index.tsx'));
const HistoricoDeCartas = React.lazy(() => import('../pages/cartasPetrobras/index.tsx'));
const EstruturasDRE = React.lazy(() => import('../pages/DRE/Estruturas/index.tsx'));

const ElaboracaoNew = React.lazy(() => import('../pages/Budget/Elaboracao/index.tsx'));

const Administration = React.lazy(() => import('../pages/Administration/index.tsx'));

const AppRoutes: React.FC = () => {
  return (
    <AuthProvider>
      <Suspense fallback={<LoadingComponent />}>
        <Routes>
          {/* Rotas nao priivadas */}
          <Route path="/login" element={<Login />} />
          <Route path="/rh/pdi/colaborador/avaliacao/:ai?" element={<PDIColaborador />} />
          <Route path="/" element={<Navigate to="/home" replace />} />

          <Route element={<PrivateRoute />}>
            <Route path="/administration" element={<Administration />} />

            {/* Aqui vão todas as rotas privadas */}
            <Route path="/home-antiga" element={<Analytics />} />
            <Route path="/home" element={<Analytics2 />} />

            <Route path="/perfil" element={<UserProfile />} />
            <Route path="/registros" element={<AdicionarDados />} />
            <Route path="/editarpermissoes" element={<EditarPermissoes />} />
            <Route path="/atualizacoes" element={<AtualizacoesDoSistema />} />
            {/* <Route path="/adicionar-atualizacoes" element={<AdicionarAtualizacoes />} /> */}

            <Route path="/comparativoanual" element={<Anual />} />
            <Route path="/comparativodiario" element={<Diario />} />
            <Route path="/comparativoperformance" element={<Performance />} />
            <Route path="/comparativomensal" element={<Mensal />} />

            <Route path="/patrimoniais/alugueisdividendos" element={<AlugueisDividendos />} />
            <Route path="/patrimoniais/acionistas" element={<ListaAcionistas />} />
            <Route path="/patrimoniais/fundodereserva" element={<ExtratoFundoDeReservas />} />
            <Route path="/dremensal" element={<DREMensal />} />
            <Route path="/drecomparativo" element={<DREComparativo />} />
            <Route path="/dre/orcadorealizado1" element={<DRERealizadoXOrcado />} />
            <Route path="/dre/orcadorealizado" element={<DreOrcadoXRealizadoNew />} />
            <Route path="/dre/realizadoxrealizado" element={<RealizadoRealizado2 />} />
            <Route path="/estruturas-dre" element={<EstruturasDRE />} />
            <Route path="/forecast" element={<Forecast />} />
            <Route path="/budget" element={<ElaboracaoNew />} />
            <Route path="/gestaocontratos" element={<GestaoContratos />} />
            <Route path="/premissas" element={<DefinicaoDePremissas />} />
            <Route path="/quadrodepessoal" element={<QuadroDePessoal />} />
            <Route path="/resumobudget" element={<ResumoBudget />} />

            <Route path="/revenuemanager" element={<RevenueManager />} />
            <Route path="/lancamento-forecast" element={<LancamentoForecast />} />

            <Route path="/buscar-cartas" element={<HistoricoDeCartas />} />
            <Route path="/registrogourmetdiario" element={<RegistroDiarioGourmet />} />
            <Route path="/registrogourmetmensal" element={<RegistroMensalGourmet />} />
            <Route path="/gourmetcontrole" element={<GourmetControle />} />
            <Route path="/rh/colaboradores" element={<Colaboradores />} />
            <Route path="/rh/colaboradores/edit" element={<NovoColaborador />} />
            <Route path="/rh/pdi" element={<PDI />} />
            <Route path="/rh/pdi/colaborador" element={<PDIColaborador />} />
          </Route>
        </Routes>
      </Suspense>
    </AuthProvider>
  );
};

export default AppRoutes;
